import { gql } from 'graphql-tag';

export const GET_LEARNING_HUB_TOPICS = gql`
  query GetLearningHubTopics($mode: LearningHubMode!) {
    getLearningHubTopics(mode: $mode) {
      id
      name
      slug
      description
      mode
      icon
      sort_order
      is_active
    }
  }
`;

export const GET_LEARNING_HUB_VIDEOS = gql`
  query GetLearningHubVideos($input: GetLearningHubVideosInput!) {
    getLearningHubVideos(input: $input) {
      count
      results {
        id
        topic_id
        topic {
          id
          name
          slug
          icon
        }
        mode
        title
        description
        vimeo_id
        duration_label
        status
        is_new
        is_featured
        help_link
        sort_order
      }
    }
  }
`;

export const GET_LEARNING_HUB_SETTINGS = gql`
  query GetLearningHubSettings {
    getLearningHubSettings {
      id
      help_base_url
      show_new_badge_days
      max_featured_videos
    }
  }
`;
